import { createContext } from 'react';
import { ConnectionState, ExecutionEvent } from '../types';

export interface SignalRContextType {
  connectionState: ConnectionState;
  joinUserGroup: (userId: string) => Promise<void>;
  leaveUserGroup: (userId: string) => Promise<void>;
  joinSessionGroup: (sessionId: string) => Promise<void>;
  leaveSessionGroup: (sessionId: string) => Promise<void>;
  joinExecutionGroup: (executionId: string) => Promise<void>;
  leaveExecutionGroup: (executionId: string) => Promise<void>;
  onExecutionEvent: (callback: (event: ExecutionEvent) => void) => void;
  onStatusUpdate: (callback: (message: string) => void) => void;
  subscribeToExecution: (executionId: string, handlers: Record<string, (event: any) => void>) => void;
  unsubscribeFromExecution: (executionId: string) => void;
  submitClarification: (executionId: string, userResponse: string) => Promise<void>;
}

export const SignalRContext = createContext<SignalRContextType | undefined>(undefined);
